import {
  Form,
  schema,
  VerificationCodeFormFormErrors,
  VerificationCodeFormType,
} from '../../forms/verificationCodeForm';

import { FormContent } from './FormContent';

interface Props {
  initialErrors?: VerificationCodeFormFormErrors;
  onSubmit: (values: VerificationCodeFormType) => void;
}

export const VerificationCodeForm = ({ initialErrors, onSubmit }: Props) => (
  <Form
    initialErrors={initialErrors}
    validationSchema={schema}
    onSubmit={onSubmit}
  >
    <FormContent />
  </Form>
);
